import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/images";

const CHAPTERS = [
  { n: "01", title: "Ponle el reloj", text: "Se lo pones en la muñeca y lo enciendes. Sin cables ni configuraciones raras." },
  { n: "02", title: "Añade contactos", text: "Desde la app apruebas quién puede llamar y creas tu primera zona segura." },
  { n: "03", title: "Listo para explorar", text: "Tu hijo sale a jugar con libertad y tú le tienes siempre a un toque." },
];

export default function HowItWorks() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.12, 1]);

  return (
    <section id="como-funciona" className="bg-white border-b-2 border-[#12263A]">
      <div className="max-w-6xl mx-auto px-5 py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <motion.span
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6 }}
              className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#2E9EF0]"
            >
              Cómo funciona — Manifiesto en 3 capítulos
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.08 }}
              className="mt-3 text-[28px] md:text-[44px] font-black text-[#12263A] leading-[1.05]"
              style={{ letterSpacing: "-0.02em" }}
            >
              Tres pasos y a la calle.
            </motion.h2>
          </div>
          <div ref={ref} className="border-2 border-[#12263A] overflow-hidden bg-[#F3F2F2]" style={{ borderRadius: "28px" }}>
            <motion.img
              style={{ scale: imgScale }}
              src={IMAGES.watchWrist}
              alt="Niño con el reloj Kiddio en la muñeca"
              className="w-full h-72 object-cover"
            />
          </div>
        </div>

        <div className="mt-16 border-t-2 border-[#12263A]">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid="step-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group grid md:grid-cols-[auto_1fr] gap-6 md:gap-12 items-baseline py-10 border-b-2 border-[#12263A]"
            >
              <span
                className="text-[64px] md:text-[92px] font-black text-[#2E9EF0] leading-none group-hover:text-[#12263A] transition-colors"
                style={{ letterSpacing: "-0.04em" }}
              >
                {c.n}
              </span>
              <div className="max-w-2xl">
                <h3 className="text-[24px] md:text-[32px] font-black text-[#12263A]">{c.title}</h3>
                <p className="mt-2 text-[17px] leading-[1.6] text-[#2A3D52]">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
